import React, { useState } from "react";
import DashboardLayout from "../../layouts/Dashboard";
import EquipmentIndicatorCRUDTable from "../../components/CRUD/Tables/EquipmentIndicatorCRUDTable";
import EquipmentIndicatorCreateModal from "./Modals/EquipmentIndicatorCreateModal";
import EquipmentIndicatorImportExcelModal from "./Modals/EquipmentIndicatorImportExcelModal";
import useReload from "../../hooks/useReload";
import { deviceIndicatorCRUD } from "../../http";
import { Button } from "@mui/material";

const EquipmentIndicatorList = () => {
    const { reload, reloadValue } = useReload();
    const [modal, setModal] = useState({
        open: false,
        mode: "create", // create | edit | details
        initialData: null,
    });
    const [importOpen, setImportOpen] = useState(false);

    const handleAddClick = () => {
        setModal({ open: true, mode: "create", initialData: null });
    };

    const handleModalClose = () => {
        setModal((s) => ({ ...s, open: false }));
    };

    const openEdit = async (id) => {
        try {
            const data = await deviceIndicatorCRUD.get(id);
            setModal({ open: true, mode: "edit", initialData: data });
        } catch (e) {
            alert(e);
        }
    };

    const openDetails = async (id) => {
        try {
            const data = await deviceIndicatorCRUD.get(id);
            setModal({ open: true, mode: "details", initialData: data });
        } catch (e) {
            alert(e);
        }
    };

    const onSubmit = async (payload) => {
        if (modal.mode === "edit") {
            await deviceIndicatorCRUD.edit(payload);
        } else {
            await deviceIndicatorCRUD.create(payload);
        }
        reload();
    };

    const onDelete = async (id) => {
        if (!window.confirm("Удалить запись?")) return;
        try {
            await deviceIndicatorCRUD.delete(id);
            reload();
        } catch (e) {
            alert(e);
        }
    };

    return (
        <DashboardLayout>
            <EquipmentIndicatorCRUDTable 
                onClickCreateButton={handleAddClick}
                onClickEditButton={openEdit}
                onClickDetailsButton={openDetails}
                onClickDeleteButton={onDelete}
                reloadValue={reloadValue}
                extraHeader={
                    <Button
                        variant="outlined"
                        size="small"
                        style={{ marginLeft: 12 }}
                        onClick={() => setImportOpen(true)}
                    >
                        Импорт Excel
                    </Button>
                }
            />
            <EquipmentIndicatorCreateModal
                open={modal.open}
                onClose={handleModalClose}
                onSubmit={onSubmit}
                mode={modal.mode}
                initialData={modal.initialData}
            />
            <EquipmentIndicatorImportExcelModal
                open={importOpen}
                onClose={() => setImportOpen(false)}
                onDone={() => {
                    setImportOpen(false);
                    reload();
                }}
            />
        </DashboardLayout>
    );
};

export default EquipmentIndicatorList;

